import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function DMCustHistoryMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.dm.customer.history("customer"));
  };

  return (
    <MainMenuItem
      itemTitleString="配信履歴(お客様)"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default DMCustHistoryMenuItem;
